<template>
  <section class="section section-white">
    <div class="container text-center fade-in-section">
      <h2 class="section-title">The QA Career Paradox</h2>
      <p class="section-subtitle max-w-4xl">Every QA professional faces the same frustrating cycle. Your skills are real, but proving them is nearly impossible.</p>
      
      <div class="problem-grid max-w-6xl">
        <div class="problem-card">
          <div class="problem-icon">🥚</div>
          <h3 class="problem-title">No Experience? No Job.</h3>
          <p class="problem-text">Companies want 2-3 years experience for "entry-level" positions. How do you get experience without a job?</p>
        </div>
        <div class="problem-card">
          <div class="problem-icon">📜</div>
          <h3 class="problem-title">Certificates Don't Cut It</h3>
          <p class="problem-text">ISTQB, CSTE, and other certs show you studied—but can't prove you can actually find bugs.</p>
        </div>
        <div class="problem-card">
          <div class="problem-icon">👻</div>
          <h3 class="problem-title">Your Work Is Invisible</h3>
          <p class="problem-text">Developers show GitHub. Designers show Dribbble. QA professionals? Nothing to show.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProblemSection'
}
</script>
